import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { routerActions } from 'connected-react-router'
import { Link } from 'react-router-dom';

import { Button } from 'react-bootstrap';

import ToggleDisplay from '../../shared/ToggleDisplay';
import Loading from '../../shared/Loading';
import FormBuilder from '../../shared/FormBuilder';

import form from './form.js';

import { loginWithUsernameAndPassword } from '../../../../app/actions/userActions';

import { authenticate, getOktaIdToken } from '../../../../lib/authentication'

const LOGIN_ERROR_MESSAGE = 'Incorrect username or password.';
const LOGIN_MIGRATION_MESSAGE = 'Your account has been migrated. You will receive an email containing instructions on how to migrate your account.'

class LoginForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            error: false,
            errorMessage: '',
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        // Hijack the initial mount + render in case we came from an external login attempt
        const {
            location: {
                query: { email, error }
            }
        } = this.props;

        if (error || email) {
            const errorMessage = this.resolveErrorMessage(error);
            this.setState({
                error: error && error.length > 0,
                errorMessage,
                email
            });
            routerActions.replace('/login');
        }
    }

    componentDidMount() {
        const { user } = this.props;
        // if user is logged in, redirect to submissions page
        // logged in user should not be able to access login screen unless they are
        // logged out
        if (user && user.username) {
            routerActions.push('/submissions');
        }
    }

    /**
     * Returns an error message from either a normal Javascript Exception instance or a string
     * representing an exception thrown from an external source
     *
     * @param {*} error
     * @returns {string}
     * @memberof LoginForm
     */
    resolveErrorMessage(error) {
        if (typeof error === 'string') {
            error = { name: error, message: null };
        }

        const errors = {
            notauthorizedexception: `${
                error.message === 'User is disabled'
                    ? `User is disabled. If you believe this is an error, please contact the administrator.`
                    : LOGIN_ERROR_MESSAGE
            }`,
            usernotfoundexception: LOGIN_ERROR_MESSAGE,
            migrationreset: 'Please contact us to reset your password.',
            internalerror: LOGIN_ERROR_MESSAGE
        };
        // XXX: Yes. This is incredibly funky.
        const { name } = error;
        const key = name || 'internalerror';
        const message = errors[key.toLowerCase()] || LOGIN_ERROR_MESSAGE;
        return message;
    }

    handleSubmit({ username = '', password = '' }) {
        username = username.trim().toLowerCase()

        this.setState({ isLoading: true });

        if (username === '') {
            this.setState({ isLoading: false, error: true, errorMessage: LOGIN_ERROR_MESSAGE });
        } else if (password === '') {
            this.setState({ isLoading: false, error: true, errorMessage: LOGIN_ERROR_MESSAGE });
        } else {
            getOktaIdToken(username, password).then()
            authenticate(username, password)
            .then(result => {
                const { idToken, status } = result

                if (!idToken && status !== 'ACTIVE') {
                    const errorMessage = status === 'MIGRATED' && LOGIN_MIGRATION_MESSAGE || LOGIN_ERROR_MESSAGE
                    this.setState({ isLoading: false, error: true, errorMessage })
                } else {
                    window.location.replace('/submissions')
                }
            })
        }
    }

    render() {
        const { email, isLoading } = this.state;

        const shouldShowError = this.state.error;
        const errorMessage = this.state.errorMessage;
        const initialValues = { username: email };

        return (
            <div>
                <div className="LoginForm__container">
                    <div className="container">
                        <div className="row">
                            <div className="md-col-12">
                                <h1>Login</h1>
                                <p>
                                    To an <strong>existing</strong> Owner&apos;s Edge account
                                </p>
                                <FormBuilder
                                    data={form}
                                    initialValues={initialValues}
                                    submitTitle="Login"
                                    submissionButtons={() => (
                                        <div>
                                            <ToggleDisplay
                                                show={shouldShowError}
                                                render={() => (
                                                    <div className="errorMessage">
                                                        {errorMessage}
                                                    </div>
                                                )}
                                            />
                                            <Button
                                                id="login-button"
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <Loading classes={['submitted']} />
                                                ) : (
                                                    'Login'
                                                )}
                                            </Button>
                                            <Link className="btn btn-link" to="forgot-password">
                                                Forgot your password?
                                            </Link>
                                        </div>
                                    )}
                                    handleSubmit={this.handleSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LoginForm.propTypes = {
    user: PropTypes.object,
    location: PropTypes.object.isRequired,
    // loginWithUsernameAndPassword: PropTypes.func
};

const mapStateToProps = state => ({
    user: state.user
});

const mapDispatchToProps = {
    loginWithUsernameAndPassword
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginForm);
